import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=75654967&scoped=true"
import script from "./accountForm.vue?vue&type=script&lang=js"
export * from "./accountForm.vue?vue&type=script&lang=js"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=75654967&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75654967",
  null
  
)

export default component.exports